import { Routes, Route } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import CompanyDashboard from "./CompanyDashboard";
import CompanyEmployees from "./CompanyEmployees";
import CompanyUsers from "./CompanyUsers";
import CompanyApprovals from "./CompanyApprovals";
import CompanyFechamento from "./CompanyFechamento";
import CompanyPayments from "./CompanyPayments";
import CompanyHistory from "./CompanyHistory";
import CompanySettings from "./CompanySettings";

export default function CompanyLayout() {
  return (
    <div className="min-h-screen bg-background" data-testid="company-layout">
      <Sidebar type="company" />
      <div className="lg:ml-64 min-h-screen">
        <Routes>
          <Route index element={<CompanyDashboard />} />
          <Route path="dashboard" element={<CompanyDashboard />} />
          <Route path="employees" element={<CompanyEmployees />} />
          <Route path="users" element={<CompanyUsers />} />
          <Route path="approvals" element={<CompanyApprovals />} />
          <Route path="fechamento" element={<CompanyFechamento />} />
          <Route path="payments" element={<CompanyPayments />} />
          <Route path="history" element={<CompanyHistory />} />
          <Route path="settings" element={<CompanySettings />} />
        </Routes>
      </div>
    </div>
  );
}
